import NotificationBell from './NotificationBell';

/** Agency console inbox (`/api/v1/agency/notifications`). */
export default function AgencyNotificationBell() {
  return <NotificationBell scope='agency' />;
}
